import { nanoid } from 'nanoid'

import { CostSummary } from '@webapp/core/components/CostSummary'
import { Price } from '@webapp/core/components/Price'
import { BudgetCategoryCardDetailsBreakdownRowIconStyled } from '../BudgetCategoryCardDetailsBreakdownRowIcon'

export interface IBudgetCategoryCargGranularSpendRowProps {
  name: string
  amount: string | number
  iconColor?: string
  iconStriped?: boolean
}

export const BudgetCategoryCardGranularSpendRow = ({
  name,
  amount,
  iconColor,
  iconStriped = false,
}: IBudgetCategoryCargGranularSpendRowProps) => {
  const id = nanoid()

  return (
    <CostSummary.Cost>
      <th id={id}>
        {iconColor && (
          <BudgetCategoryCardDetailsBreakdownRowIconStyled
            color={iconColor}
            striped={iconStriped}
          />
        )}
        {name}
      </th>
      <td aria-labelledby={id}>
        <Price price={amount} />
      </td>
    </CostSummary.Cost>
  )
}

BudgetCategoryCardGranularSpendRow.displayName =
  'BudgetCategoryCardGranularSpendRow'
